import React, { useEffect, useState, useRef } from "react";
import styled, { createGlobalStyle } from "styled-components";
import { Confirm } from 'notiflix/build/notiflix-confirm-aio';
import Config from "./Config";
import Rules from "./partials/Rules";
import TC from "./partials/TC";
import News from './partials/News';
import Trophies from './partials/Trophies';
import Tournaments from './partials/Tournaments';
import MyAccount from "./partials/MyAccount";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRankingStar, faUsers, faClipboardCheck, faHouse } from '@fortawesome/free-solid-svg-icons'

import Ranking from "./Ranking"
import MySquad, {changeMemberInSquadToEmpty} from "./Squad";
import {MiniLeague} from "./partials/MiniLeagues"
import Extra from "./Extra";
import Footer from "./partials/Footer";

import {Col, Container} from 'reactstrap';

import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import _ from './Trans'

import {BrowserRouter, Route, NavLink, Link} from 'react-router-dom';
import SlideRoutes from 'react-slide-routes';
import InviteFriends from "./partials/InviteFriends";
import token from "./AuthToken";
import {getTrophies, acknowledgeTrophy} from "./partials/ApiCalls";

let audio = new Audio(Config.unlockedTrophySoundUrl);

// require("./css/"+Config.appCustomer+"/styles.scss");
require("./css/asobal/styles.scss");

function App({ assetMap }) {
  const [windowDimension, setWindowDimension] = useState(null);
  const [squad, setSquad] = useState({squad_members: []});
  const [squads, setSquads] = useState([]);
  const [tournament, setTournament] = useState(null);
  const [trophies, setTrophies] = useState(null);
  const alreadyNotified = useRef(new Set());
  const [hasInteracted, setHasInteracted] = useState(false);
  let trophiesTriggered = false

  useEffect(() => {
    setWindowDimension(window.innerWidth);
  }, []);

  useEffect(() => {
    function handleResize() {
      setWindowDimension(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
        if(!window.location.href.includes("/rules/") && !window.location.href.includes("/tc/")) {
            fetchSquads()
        }
  }, []); // eslint-disable-line

  useEffect(() => setTournament(squad?.tournament), [squad]);

    const fetchSquads = async () => {
        return fetch(Config.squadApiUrl, {
                headers: {
                    Authorization: 'Token ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .then((e) => {
                if (e.status < 300) {
                    return Promise.resolve(e.json())
                }
                if(e.status === 401) {
                    window.location.href = Config.logoutPage;
                }
                return Promise.reject(e)
            })
            .then((d) => {
                setSquads(d.results);
                return d;
            })
            .then((d) => {
                // todo unify this with change squad
                _cleanSquad();
                for (let j = 0; j < d.results.length; j++) {
                    if (d.results[j].active) {
                        setSquad(d.results[j]);
                        setTournament(d.results[j].tournament);
                    }
                }
            })
            .catch((e) => {
                console.log("Caught error in fetchSquad: "+e)
                // window.location.href = Config.logoutPage;
            })
    }

    const changeTournament = function(id) {
        setTournament(id);
        _cleanSquad();
    }

    useEffect(() => {
        if(squads === undefined) {
            console.error("Squads detected as undefined", squads);
            return;
        }
        if(squads.length < 1) {
            return;
        }
        if(squads.length === 1) {
            setSquad(squads[0]);
        }
        for(let i=0; i<squads.length; i++) {
            if(squads[i].active) {
                setSquad(squads[i]);
                break;
            }
        }

        getTrophies(setTrophies);
    }, [squads]);

    useEffect(() => {
        function handleUserInteraction() {
            setHasInteracted(true);
            events.map(e => window.removeEventListener(e, handleUserInteraction));
        }

        const events = ['click', 'keydown', 'touchstart', 'mousedown'];
        events.map(e => window.addEventListener(e, handleUserInteraction));

        return () => {
            events.map(e => window.removeEventListener(e, handleUserInteraction));
        };
    }, []);

    useEffect(() => {
        const notify = async () => {
            let timer = 3000;
            let counter = 0;
            if (trophies?.length > 0) {
                for (let i = 0; i < trophies.length; i++) {
                    let t = trophies[i];
                    if(t?.acknowledged != null && !t?.acknowledged && !alreadyNotified.current.has(t.id)) {
                        try {
                          setTimeout(() => {
                            toast.success(
                              <div style={{marginLeft: "20px"}}><Link to="/trophies/">{t.name}</Link></div>,
                              {
                                ...Config.toastConfig,
                                autoClose: 3000,
                                icon: (
                                  <img
                                    width="40px"
                                    src={process.env.REACT_APP_PUBLIC_URL + t.image}
                                    alt={t.name}
                                  />
                                ),
                              }
                            );

                            audio.play();

                            acknowledgeTrophy(t.id, alreadyNotified);
                          }, timer * counter);
                          counter++;
                        } catch (e) {
                            console.error('Error al reproducir el audio:', e);
                        }
                    }
                }
                trophiesTriggered = false; // eslint-disable-line
            }
        };

        if(hasInteracted && trophies != null && trophies.length > 0 && !trophiesTriggered) {
            trophiesTriggered = true;
            notify();
        }
    }, [trophies, hasInteracted]);

    function _cleanSquad() {
        new Promise((resolve, reject) => {
            for (let j = 0; j < 9; j++) {
                changeMemberInSquadToEmpty(j);
            }
        })
    }

    const selectAnotherTeam = function(event) {
        // todo unify this with SquadHeader.Update
        const targetSquad = event.target.dataset.squadIdPosition;

        let data = {
            active: true
        }
        const squadApiUrlUpdate = Config.squadApiUrl + targetSquad + "/";

        fetch(squadApiUrlUpdate, {
            method: 'PUT',
            headers: {
                Authorization: 'Token ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then((response) => {
            if (response.status < 200 || response.status > 300) {
                console.log(response);
                throw new Error(_("Error switching team"))
            }
            if(squad.id != event.target.dataset.squadIdPosition) { // eslint-disable-line
                _cleanSquad();
                const i = parseInt(event.target.dataset.squadIdPosition);
                for (let j = 0; j < squads.length; j++) {
                    if (squads[j].id === i) {
                        setSquad(squads[j]);
                    }
                }
            }
        })
        .catch((ex) => {
            console.error(ex)
            toast.error(_("Error switching team"), Config.toastConfig)
        })
    }

  const isMobile = windowDimension <= Config.MAX_MOBILE_WINDOW_DIMENSION;

  const scrollUp = () => window.scrollTo(0, 0);

  let mobileNavbar = (
      <MobileNavbar.Wrapper className="mobile-navbar">
          <MobileNavbar.Items className="mobile-navbar-items">
              <NavLink to="/squad/" data-index="1" onClick={scrollUp} className="d-none">
                  <MobileNavbar.Item className="text-center mobile-navbar-item">
                      <FontAwesomeIcon icon={faHouse}/><br/><span className="mobile-navbar-text">{_('Return')}</span>
                  </MobileNavbar.Item>
              </NavLink>
              <NavLink to="/squad/" data-index="1" onClick={scrollUp}>
                  <MobileNavbar.Item className="text-center mobile-navbar-item">
                      <FontAwesomeIcon icon={faUsers}/><br/><span className="mobile-navbar-text">{_('My team')}</span>
                  </MobileNavbar.Item>
              </NavLink>
              <NavLink to="/ranking/" onClick={scrollUp}>
                  <MobileNavbar.Item className="text-center mobile-navbar-item">
                      <FontAwesomeIcon icon={faRankingStar}/><br/><span className="mobile-navbar-text">{_('Ranking')}</span>
                  </MobileNavbar.Item>
              </NavLink>
              <NavLink to="/extra/" onClick={scrollUp}>
                  <MobileNavbar.Item className="text-center mobile-navbar-item">
                      <FontAwesomeIcon icon={faClipboardCheck}/><br/><span className="mobile-navbar-text">{_('Extra')}</span>
                  </MobileNavbar.Item>
              </NavLink>
          </MobileNavbar.Items>
      </MobileNavbar.Wrapper>
  );

  const textDecorationNone = {'textDecoration': 'none'};
  let navbar =
      <Navbar.Wrapper className="d-block">
          <Container>
              <Navbar.Logo className="d-none">
                  <Col className="font-weight-bold text-left" id="squad-name-title">
                    <Logo project={Config.appCustomer}/>
                  </Col>
              </Navbar.Logo>
              <Navbar.Items className="h5 d-flex justify-content-between w-100">
                  <NavLink to="/squad/" style={textDecorationNone} onClick= {scrollUp}><Navbar.Item className="navbar-item">{_('My team')}</Navbar.Item></NavLink>
                  <NavLink to="/rules/" className="d-xs-none d-sm-none d-md-block" style={textDecorationNone}><Navbar.Item className="navbar-item">{_('Rules')}</Navbar.Item></NavLink>
                  <NavLink to="/ranking/" style={textDecorationNone}><Navbar.Item className="navbar-item">{_('Ranking')}</Navbar.Item></NavLink>
                  {/*<NavLink to="/profile/" style={textDecorationNone}><Navbar.Item className="navbar-item">{_('My account')}</Navbar.Item></NavLink>*/}
                  <NavLink to="/extra/" style={textDecorationNone}><Navbar.Item className="navbar-item">{_('Extra')}</Navbar.Item></NavLink>
              </Navbar.Items>
          </Container>
      </Navbar.Wrapper>;

    const shouldDisplayAlert = function(alerts) {
        return false;
        /*
        const TIME_TO_DISPLAY_AGAIN = 1000 * 60 * 60 * 24;
        // const TIME_TO_DISPLAY_AGAIN = 1000 * 60;  // test purposes
        return alerts?.match35405097 === undefined || (
            (new Date().getTime() - alerts?.match35405097?.lastTimeDisplayed > TIME_TO_DISPLAY_AGAIN)
            && alerts?.match35405097?.showAgain === true
        )
        */
    }

    useEffect(() => {
        let alerts = localStorage.getItem('alerts');
        if(alerts === undefined) {
            alerts = {};
        }
        alerts = typeof alerts === 'string' ? JSON.parse(alerts) : {};
        // 1 day = 86400000
        if(shouldDisplayAlert(alerts)) {
            Confirm.show(
                _("Notice for round 27"),
                _('On April 17, an advanced match of the current round was played, the match <b>Barça - Ademar León</b>.<br><br>The players of these teams will not score points in the game this day. We recommend selling it for round 27. Their statistics will be saved, but prices will not change.<br><br>On round 28 all teams will score again normally.<br><br>Consult <a href="/rules/#other-considerations" class="font-weight-bold">the rules, section Other considerations</a>, to know more about this.'),
                _('Acknowledge'),
                _('Do not show again'),
                () => {
                    if(alerts !== 'object') {
                        alerts = {};
                    }
                    alerts.match35405097 = {lastTimeDisplayed: new Date().getTime(), showAgain: true}
                    localStorage.setItem('alerts', JSON.stringify(alerts));
                },
                () => {
                    if(alerts !== 'object') {
                        alerts = {};
                    }
                    alerts.match35405097 = {lastTimeDisplayed: new Date().getTime(), showAgain: false}
                    localStorage.setItem('alerts', JSON.stringify(alerts));
                },
                {
                    width: "350px",
                    plainText: false,
                    messageMaxLength: 5000,
                    cancelButtonBackground: 'grey'
                }
            );
            /*Notiflix.Report.success(
                "¡Haz tus cambios ahora!",
                'El partido Barça - León del martes pasado no cuenta. Si vendes hoy ganarás mañana.<br>Mira las instrucciones para saber cómo hemos arreglado esto.',
                _('Close')
            );*/
        }
    }, []);

  return (
    <BrowserRouter>
        <CSSReset/>

                {Config.appCustomer.toUpperCase() === 'ASOBAL' ?
                    <Logo project={Config.appCustomer} isMobile={false}/>
                    :
                    <Navbar.Logo className={isMobile ? "d-none": ""}>
                       <Col className="font-weight-bold text-left" id="squad-name-title">
                          <Logo project={Config.appCustomer}/>
                       </Col>
                    </Navbar.Logo>
                }
              {isMobile && !Config.appCustomer.toUpperCase() === 'ASOBAL' ? (
                  <Logo project={Config.appCustomer} isMobile={isMobile}/>
              ): (
                  <div className='d-none'></div>
              )}

              {isMobile ? "" : navbar}
      <SlideRoutes>
        <Route path='/' element={<head><meta httpEquiv="refresh" content="0; url=/squad/"/></head>}/>
        <Route path="/squad/" element={<MySquad squad={squad} fetchSquads={fetchSquads} project={Config.appCustomer} squads={squads} selectAnotherTeam={selectAnotherTeam} tournament={tournament}/>} />
        <Route path="/rules/" element={<Rules />} />
        <Route path="/tc/" element={<TC />} />
        <Route path="/ranking/" element={<Ranking squad={squad} tournament={tournament}/>} />
        <Route path="/extra/" element={<Extra />} />
        <Route path="/invite-friends/" element={<div><InviteFriends /></div>} />
        <Route path="/tournaments/" element={<Tournaments setTournament={changeTournament}/>} />
        <Route path="/profile/" element={<div><MyAccount /></div>} />
        <Route path="/news/" element={<div><News /></div>} />
        <Route path="/trophies/" element={<div><Trophies /></div>} />
        <Route path="/mini-league/" element={<div><MiniLeague /><div style={{height: "100px", minHeight: "100px"}}/></div>} />
      </SlideRoutes>
        <ToastContainer />
      {isMobile ? mobileNavbar : <Footer/>}
    </BrowserRouter>
  )
}

const Logo = function({project, isMobile}) {
    if(project.toUpperCase() === 'ASOBAL') {
        return (
            <div className="text-center logo">
               <img src={Config.logoAsobalUrl} width="35%" style={{maxWidth: '310px'}} alt="Logo Asobal"/>
            </div>
        )
    }
    let extraStyle = {marginRight: "5%"};
    let extraImageStyle = {width: "10%"}
    if(isMobile) {
        extraStyle = {marginRight: "5%"}
        extraImageStyle = {width: "15%"}
    }
    return (
        <div className="h1 text-center" style={extraStyle}>
            <img src={Config.logoOlympicsUrl} style={extraImageStyle} alt="Logo Olympics 2024"/>Supermanager
        </div>
    )
}

const Navbar = {
  Wrapper: styled.nav`
    flex: 1;
    align-self: flex-start;
    padding: 0.8rem 0rem 0.1rem 0rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: 'The Seasons', serif;
  `,
  Logo: styled.h1`
    border: 0;
    padding: 0.0rem 1rem;
  `,
  Items: styled.ul`
    display: flex;
    list-style: none;
  `,
  Item: styled.li``,
};

const MobileNavbar = {
  Wrapper: styled(Navbar.Wrapper)``,
  Items: styled(Navbar.Items)``,
  Item: styled(Navbar.Item)``,
};

const CSSReset = createGlobalStyle`
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
  }

  html, body {
    text-transform: uppercase !important;
    //background-image: url(${Config.backgroundAsobalUrl});
    /*background-color: rgba(34, 52, 142, 0.09);*/
    background-size: cover;
    background-attachment: fixed;
    min-height: 100vh;
  }

  /* Squad */
  .court {
    background: url(${Config.handballCourtImageUrl});
    background-size: 100% auto;
    width: 100%;
  }

  .transparent {
    opacity: 0;
  }
`;

export default App;